import CryptoJS from 'crypto-js';
import { v4 as uuid } from 'uuid';

class CipherService {
  private secretKey: string;

  constructor() {
    this.secretKey = uuid().replace(/-/g, '').slice(0, 16);
  }

  getSecretKey(): string {
    return this.secretKey;
  }

  encryptWithKey(secret: string, text: string): string {
    const key = CryptoJS.enc.Hex.parse(CryptoJS.enc.Utf8.parse(secret).toString(CryptoJS.enc.Hex));
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    const ciphertext = encrypted.toString();

    return ivBase64 + ':' + ciphertext;
  }

  decryptWithKey(secret: string, combined: string): string {
    const [ivBase64, ciphertext] = combined.split(':');
    const key = CryptoJS.enc.Utf8.parse(secret);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);

    const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encrypt(text: string): string {
    return this.encryptWithKey(this.secretKey, text);
  }

  decrypt(encryptedString: string): string {
    return this.decryptWithKey(this.secretKey, encryptedString);
  }
}

const cipherServiceInstance = new CipherService();
export default cipherServiceInstance;
